export class BreadCrumb{
    constructor(
        public name: string,
        public location: string) { }
}


// WEBPACK FOOTER //
// ./src/app/shared/breadcrumb/breadcrumb.model.ts